import { createTripleButton } from '../../../../common/view/button/triple-button/triple-button';
import { FontSize, FontWeight } from '../../../../common/view/font';

export const SideBarItem = createTripleButton(
  {
    sizing: {
      shrinkX: '10px',
      shrinkY: '8px',
      borderRadius: '4px',
      gap: '8px',
    },
    background: {
      color: {
        base: {
          normal: 'rgba(255, 255, 255, 0.0)',
          hover: 'rgba(255, 255, 255, 0.1)',
        },
        selected: {
          normal: 'rgba(255, 255, 255, 0.1)',
          hover: 'rgba(255, 255, 255, 0.2)',
        },
      },
    },
    icon: {
      size: '16px',
      color: {
        base: {
          normal: 'rgba(255, 255, 255, 0.2)',
          hover: 'rgba(255, 255, 255, 0.4)',
        },
        selected: {
          normal: 'rgba(255, 255, 255, 0.4)',
          hover: 'rgba(255, 255, 255, 0.6)',
        },
      },
    },
    text: {
      size: FontSize.l1,
      weight: FontWeight.l1,
      color: {
        base: {
          normal: 'rgba(255, 255, 255, 0.7)',
          hover: 'rgba(255, 255, 255, 0.9)',
        },
        selected: {
          normal: 'rgba(255, 255, 255, 0.9)',
          hover: 'rgba(255, 255, 255, 1)',
        },
      },
    },
    config: {
      componentId: 'side-bar-item',
      displayName: 'SideBarItem',
    },
  },
  { mouseUpMode: true },
);
